import { getDeviceId } from '@/utils/getDeviceId';
import { PosState, userStoreType } from '../../redux/auth/authTypes';
import api from '../axios/axiosInstance';

export interface LoginResponse {
  _id: string;
  email: string;
  name: string;
  avatar: string;
  roles: string[];
  country: string;
  access_token: string;
  refresh_token: string;
  devicePOS: PosState;
  emailVerified: boolean;
  userPosCount: number;
  userStores?: userStoreType[];
}
export interface loginForm {
  email?: string;
  password?: string;
  deviceId?: string;
  accessToken?: string;
}

const login = async (data: loginForm): Promise<LoginResponse> => {
  const deviceId = await getDeviceId();
  const response = await api.post('/users/login', { ...data, deviceId });
  return response.data;
};

export default login;
